import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BasicLayoutComponent } from './layout/basic-layout/basic-layout.component';
import { BlankLayoutComponent } from './layout/blank-layout/blank-layout.component';

import { AuthGuard } from './helpers/auth.guard';
import { NotAuthComponent } from 'projects/shared/src/pages/not-auth/not-auth.component';
import { ErrorComponent } from 'projects/shared/src/pages/error/error.component';

const routes: Routes = [
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '', component: BasicLayoutComponent,
    children: [
      { path: '', redirectTo: (localStorage.getItem('baseRoute') || 'complaints'), pathMatch: 'full' },
      { path: 'user-profile', loadChildren: () => import('./features/user-profile/user-profile.module').then(m => m.UserProfileModule), canActivate: [AuthGuard] },
      { path: 'reports', loadChildren: () => import('./features/reports/reports.module').then(m => m.ReportsModule), canActivate: [AuthGuard] },
      { path: 'complaints', loadChildren: () => import('./features/complaints/complaints.module').then(m => m.ComplaintsModule), canActivate: [AuthGuard] }
    ]
  },
  {
    path: '', component: BlankLayoutComponent,
    children: [
      // { path: '', redirectTo: (localStorage.getItem('baseRoute') || ''), pathMatch: 'full' },
      { path: '', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
    ]
  },

  { path: 'notAuthorized', component: NotAuthComponent },
  { path: 'notFound', component: ErrorComponent },
  { path: '**', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
